import { Button } from "@/lib/components/Button/Button";
import { cn } from "@/lib/utils";
import { IconChevronLeft } from "@tabler/icons-react";

type Props = {
  title: string;
  subtitle?: string;
  isVisible?: boolean;
  onBackClicked?: () => void;
  classNameTitle?: string;
};

export default function TabTitle({
  title,
  subtitle,
  isVisible = true,
  onBackClicked,
  classNameTitle,
}: Props) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`${onBackClicked ? "pt-4.5 pr-6 pb-3.5 pl-3" : "px-6 pt-6 pb-5"}`}
    >
      <div className="flex flex-row items-center">
        {onBackClicked && (
          <Button variant={"ghost"} size={"iconXs"} onClick={onBackClicked}>
            <IconChevronLeft />
          </Button>
        )}
        <h2 className={cn("text-md font-semibold", classNameTitle)}>{title}</h2>
      </div>

      {subtitle && (
        <p className="mt-0.5 text-sm text-text-secondary">{subtitle}</p>
      )}
    </div>
  );
}
